import {
  cloneDataOrNull,
  cloneListOfCloneable,
  DataModelBuilder,
  isSameData,
  isSameList,
  SerializationContext,
  SerializedData,
} from '../../models/dto/dto.js';
import { MapLocation } from '../../models/serializable/map-location.js';
import { PhotoReference } from '../../models/serializable/file-reference/photo-reference.js';
import { MapUtils } from '../../utility/map-utils.js';
import { isNotNullOrUndefined } from '../../utility/null-safety.js';
import { Component } from '../core/component.js';

export class AdvertLocationComponent extends Component {
  static readonly TYPE_ID: string = '183e2c4561cd4b83990cfc56b061035e';

  constructor(
    public readonly locations: MapLocation[],
    public readonly mapPreview: PhotoReference | null = null,
    public readonly mapUrl: string | null = null,
  ) {
    super();
  }

  get hasMapPreview(): boolean {
    return isNotNullOrUndefined(this.mapPreview);
  }

  get $removable(): boolean {
    return false;
  }

  get $typeId(): string {
    return AdvertLocationComponent.TYPE_ID;
  }

  static empty(): AdvertLocationComponent {
    return new AdvertLocationComponent([]);
  }

  static fromMap(context: SerializationContext, map: SerializedData): AdvertLocationComponent {
    return new AdvertLocationComponent(
        MapUtils.getList<MapLocation>(map, 'locations', (e) => {
          return context.fromData(e as SerializedData);
        }),
        context.fromDataOrNull<PhotoReference>(MapUtils.getOrNull<SerializedData>(map, 'mapPreview')),
        MapUtils.getOrNull(map, 'mapUrl'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'locations': this.locations.map((e) => context.toData(e)),
      'mapPreview': context.toDataOrNull(this.mapPreview),
      'mapUrl': this.mapUrl,
    };
  }

  clone(): this {
    return new AdvertLocationComponent(
        cloneListOfCloneable(this.locations),
        cloneDataOrNull(this.mapPreview),
        this.mapUrl,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameList(other.locations, this.locations, (a, b) => isSameData(a, b)) &&
      isSameData(other.mapPreview, this.mapPreview) &&
      other.mapUrl === this.mapUrl;
  }
}

export class AdvertLocationComponentBuilder extends DataModelBuilder<AdvertLocationComponent> {
  build(context: SerializationContext, map: SerializedData): AdvertLocationComponent {
    return AdvertLocationComponent.fromMap(context, map);
  }
}
